import React, { useState, createRef, useEffect, useRef } from "react";
import { docusignAccess } from "./services/docusignService";
import { getFieldName } from "../scripts/helperScripts";
// import { useScreenshot } from "use-react-screenshot";
import docusignForms from "./forms/docusignForms";
import DocusignModal from "./forms/DocusignModal";
import { getUsers } from "./services/soar";

function Docusign({ clientProgram, careTeam, forms, clearDocusignList }) {
  const [data, setData] = useState();
  let docusignFormsCopy = JSON.parse(JSON.stringify({ ...docusignForms }));
  const isMountedRef = useRef(true);
  const [token, setToken] = useState();
  const pdfRef = createRef(null);
  // const [image, takeScrenshot] = useScreenshot();
  // const getImage = () => {
  //   takeScrenshot(pdfRef.current);
  // };
  const user = JSON.parse(localStorage.getItem("safyInfo")).user;
  const clientId = clientProgram["con.contactid"]; // "19A9FC95-D12D-EC11-8DDD-000C295EBA08";
  const clientName = `${clientProgram["con.firstname"]} ${clientProgram["con.lastname"]}`; //"Assessment Test";
  const clientEmail =
    process.env.REACT_APP_ENVIRONMENT === "Production" &&
    clientProgram["con.emailaddress1"]
      ? clientProgram["con.emailaddress1"]
      : user.email;
  const [internalOptions, setInternalOptions] = useState([]);
  const [externalOptions, setExternalOptions] = useState([]);
  const [safyUsers, setSafyUsers] = useState([]);
  const regardingOrg =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "SOARLive"
      : "SOARD365Base";

  //GET Docusign Token on load
  useEffect(() => {
    if (isMountedRef.current) {
      docusignToken();
    }
    return () => (isMountedRef.current = false);
  }, []);

  //SET Internal and External options from CareTeam
  useEffect(() => {
    if (careTeam) {
      //set Internal Recipients
      const internal = careTeam
        .filter((ct) => ct.ccx_memberid !== undefined)
        .map((member) => {
          return {
            _id: member["user.internalemailaddress"],
            name: formatName(getFieldName(member.ccx_memberid)),
          };
        });

      const unique = [
        ...new Map(internal.map((item) => [item["name"], item])).values(),
      ];
      setInternalOptions(unique);

      //set External Recpients
      let external = careTeam
        .filter((ct) => ct.ccx_memberid === undefined)
        .map((member) => {
          return {
            _id:
              process.env.REACT_APP_ENVIRONMENT === "Production" &&
              member["con.emailaddress1"]
                ? member["con.emailaddress1"]
                : user.email,
            name: `${formatName(
              getFieldName(member.ccx_contact)
            )} (${getFieldName(member.sor_contactrole)})`,
          };
        });
      external.splice(0, 0, {
        _id: clientEmail,
        name: `${clientName} (client)`,
      });
      setExternalOptions(external);
    }
  }, []);

  useEffect(() => {
    if (isMountedRef.current) {
      getUsers().then((response) => {
        if (response) {
          const users = response.map((u) => ({
            _id: u.internalemailaddress,
            name: u.fullname,
          }));
          setSafyUsers(users);
        }
      });
    }
    return () => (isMountedRef.current = false);
  }, []);

  useEffect(() => {
    if (forms && forms.length > 0) {
      selectForm(forms);
      clearDocusignList();
    }
  }, [forms]);

  const docusignToken = async () => {
    var access = await docusignAccess();
    console.log(
      `Docusign Token: account_id: ${access.account_id} base_uri: ${access.base_uri}`,
      access
    );
    setToken(access);
  };

  const selectForm = (selectedForm) => {
    const form = selectedForm;
    console.log("Form", form[0].FormDescription);
    let compositeTemplate = {
      emailSubject: `SAFY document "${form[0].FormDescription}" for ${clientName}`,
      status: "sent",
      compositeTemplates: form,
    };
    console.log(
      "Setting Docusign Initial CompositeTemplate",
      compositeTemplate
    );

    //Set Inline Templates and Custom Fields
    //Set Server Templates
    for (let i = 0; i < form.length; i++) {
      compositeTemplate.compositeTemplates[i].inlineTemplates[0].sequence =
        i + 1;
      compositeTemplate.compositeTemplates[i].inlineTemplates[0].customFields =
        {
          textCustomFields: [
            {
              fieldId: "0",
              name: "RegardingID",
              requried: false,
              show: false,
              value: clientProgram.ccx_client_programid,
            },
            {
              fieldId: "1",
              name: "RegardingName",
              required: false,
              show: false,
              value: `${clientName}-${clientProgram.ccx_name}`,
            },
            {
              fieldId: "2",
              name: "RegardingOrg",
              required: false,
              show: false,
              value: regardingOrg,
            },
          ],
        };

      compositeTemplate.compositeTemplates[i].serverTemplates[0].sequence =
        i + 1;
    }

    //Insert Prefill Data
    compositeTemplate = PrefillData(compositeTemplate);

    console.log("Setting Docusign Data", compositeTemplate);
    setData(compositeTemplate);
    //setIsOpen(true);
  };

  const PrefillData = (compositeTemplate) => {
    let newTemplate = { ...compositeTemplate };
    newTemplate.compositeTemplates.forEach((template) => {
      template.inlineTemplates.forEach((inlineTemplate) => {
        inlineTemplate.recipients.signers.forEach((signer) => {
          if (
            signer.tabs &&
            signer.tabs.textTabs &&
            signer.tabs.textTabs.length > 0
          ) {
            signer.tabs.textTabs.forEach((tab) => {
              switch (tab.tabLabel) {
                case "con.fullname":
                  tab.value = `${clientProgram["con.firstname"]} ${clientProgram["con.lastname"]}`;
                  break;
                case "con.birthdate":
                  tab.value =
                    clientProgram["con.birthdate"] &&
                    clientProgram["con.birthdate"]["@date"].toString();
                  break;
                case "PlacementDate":
                  tab.value = clientProgram.ccx_admitdate["@date"];
                  break;
                case "con.ssn4":
                  tab.value =
                    clientProgram["con.ccx_ssn"] &&
                    clientProgram["con.ccx_ssn"].slice(-4);
                  break;
                case "fac.street1":
                  tab.value = clientProgram["fac.street1"] || "";
                  break;
                case "fac.street2":
                  tab.value = clientProgram["fac.street2"] || "";
                  break;
                case "fac.street3":
                  tab.value = clientProgram["fac.street3"] || "";
                  break;
                case "fac.city":
                  tab.value = clientProgram["fac.city"] || "";
                  break;
                case "fac.state":
                  tab.value = clientProgram["fac.state"] || "";
                  break;
                case "fac.county":
                  tab.value = clientProgram["fac.county"] || "";
                  break;
                case "fac.postalcode":
                  tab.value = clientProgram["fac.postalcode"] || "";
                  break;
                case "fac.phone1":
                  tab.value = clientProgram["fac.phone1"] || "";
                  break;
                case "fac.phone2":
                  tab.value = clientProgram["fac.phone2"] || "";
                  break;
                case "fac.phone3":
                  tab.value = clientProgram["fac.phone3"] || "";
                  break;
                case "fac.fax":
                  tab.value = clientProgram["fac.fax"] || "";
                  break;
                case "company":
                  tab.value = clientProgram.ccx_company["@name"] || "";
                  break;
              }
            });
          }
          if (!signer.Type || signer.Type !== "Internal") {
            signer.adhoc = true;
          }
        });
      });
    });

    console.log("Prefill Template", compositeTemplate);
    return compositeTemplate;
  };

  const formatName = (name) => {
    let ctName = name.split(", ");
    ctName = ctName[1] ? `${ctName[1]} ${ctName[0]}` : ctName[0];
    return ctName;
  };

  const clearData = () => {
    setData(null);
  };

  return (
    <>
      {data ? (
        <DocusignModal
          compositeTemplates={data}
          internalOptions={internalOptions}
          externalOptions={externalOptions}
          safyUsers={safyUsers}
          open={true}
          token={token}
          clearData={clearData}
        ></DocusignModal>
      ) : null}
      <br />
    </>
  );
}

export default Docusign;
